export const FETCH_CONTEXTUALIZED_SIGNUP_PAGES_AUTH = "FETCH_CONTEXTUALIZED_SIGNUP_PAGES_AUTH";
export const FETCH_CONTEXTUALIZED_SIGNUP_PAGES_AUTH_SUCCESS =
	"FETCH_CONTEXTUALIZED_SIGNUP_PAGES_AUTH_SUCCESS";
